const getters = {
    product: (state) => state.product,
    productID: (state) => state.productID,
    loading: state => state.loading,
    documents: (state) => state.documents,
    file: state => state.file,
    docLoader: state => state.docLoader,
};

export default getters;